import { render, staticRenderFns } from "./schedule-training.vue?vue&type=template&id=564e8ed5&"
import script from "./schedule-training.vue?vue&type=script&lang=js&"
export * from "./schedule-training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports